import { Component, Input, OnInit } from '@angular/core';
import { ScheduleOrderResponse } from '../../../../models/schedule.model';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FlowChartComponent } from '../../../flow-chart/flow-chart.component';

@Component({
  selector: 'app-schedule-order-status-visual',
  standalone: true,
  imports: [
    MatCardModule,
    MatIconModule,
    CommonModule,
    FlowChartComponent,
  ],
  templateUrl: './schedule-order-status-visual.component.html',
  styleUrl: './schedule-order-status-visual.component.scss'
})
export class ScheduleOrderStatusVisualComponent {

  @Input() scheduleOrder: ScheduleOrderResponse;

  calculateNextScheduleOrderStatus(scheduleOrder:ScheduleOrderResponse): string | null {
    if (scheduleOrder && scheduleOrder.status) {
      switch (scheduleOrder.status) {
        case 'Scheduled':
          return 'InProgress';
        case 'InProgress':
          return 'Completed';
        case 'Completed':
          return null;
        case 'Cancelled':
          return null;
        default: 
          return null; 
      }
    }
    return null;
  }

  isStatusActive(status: string): boolean {
    if (!this.scheduleOrder) {
      return false;
    }
    if (this.scheduleOrder.status === 'Cancelled'){
      return false;
    }
    if (status === 'Scheduled') {
      return this.scheduleOrder.status === 'Scheduled' || this.scheduleOrder.status === 'InProgress' || this.scheduleOrder.status === 'Completed';
    } else if (status === 'InProgress') {
      return this.scheduleOrder.status === 'InProgress' || this.scheduleOrder.status === 'Completed';
    } else if (status === 'Completed') {
      return this.scheduleOrder.status === 'Completed';
    }
    return false;
  }

  isStatusNext(status: string): boolean {
    if (!this.scheduleOrder) {
      return false;
    }
    return this.calculateNextScheduleOrderStatus(this.scheduleOrder) === status;
  }


}
